// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1CePO","ranges":"BmiRanges_ranges__31Esf"};